import { render, staticRenderFns } from "./lazybox.vue?vue&type=template&id=1e0b6c62&"
import script from "./lazybox.vue?vue&type=script&lang=js&"
export * from "./lazybox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/lazybox.vue"
export default component.exports